import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { startPortalEmbedHeightReporting } from './app/core/utils/portal-embed-height';

registerLocaleData(localeDe);

// Before bootstrap, so the host page's `height-0` request is not missed.
startPortalEmbedHeightReporting();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
